import React, { Fragment, useEffect, useState } from "react";
import "./centralRevenueLossModal.css";
import { CentralModal } from "../CentralModal/CentralModal";
import { useDispatch, useSelector } from "react-redux";
import { CentralRevenueLossStatus } from "../../../_services";
import { CentralSelect } from "../CentralSelect/CentralSelect";
import { CentralInputField } from "../CentralInputField/CentralInputField";
import { toast } from "react-toastify";
import { centralReportingDataActions, configActions } from "../../../_actions";

const REVENUE_LOSS_TYPES = [
  { value: "Insurance Rejection", label: "Insurance Rejection" },
  { value: "Conservative", label: "Conservative" },
  { value: "Absconded", label: "Absconded" },
  { value: "Extra Night", label: "Extra Night" },
  { value: "Extra Cash (Deductions)", label: "Extra Cash (Deductions)" },
  { value: "Extra Cash (IA Miss)", label: "Extra Cash (IA Miss)" },
];

export const CentralRevenueLossModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [revenueLossType, setRevenueLossType] = useState("");
  const [collectibleAmount, setCollectibleAmount] = useState("");
  const [collectedAmount, setCollectedAmount] = useState("");
  const reportingData = useSelector(state => state.centralReportingData);
  const appId = useSelector(state => state.centralPatients.activePatientId);
  const dispatch = useDispatch();

  const activePatientData = reportingData?.reportingData?.data?.find(
    item => item.appointment_id === appId || item._id === appId
  );

  useEffect(() => {
    if (activePatientData) {
      if (activePatientData.revenueLossReason) {
        setRevenueLossType(activePatientData.revenueLossReason);
      }
      if (activePatientData.revenueLossCollectibleAmount) {
        setCollectibleAmount(activePatientData.revenueLossCollectibleAmount);
      }
      if (activePatientData.revenueLossCollectedAmount) {
        setCollectedAmount(activePatientData.revenueLossCollectedAmount);
      }
    }
  }, [activePatientData]);

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const isDataValid = () => {
    return revenueLossType && collectibleAmount && collectedAmount;
  };

  const handleSubmit = async (e) => {
    if (!appId || !revenueLossType || !collectibleAmount || !collectedAmount) {
      toast.error('All fields are required');
      return;
    }
    dispatch(configActions.showSpinningLoader());
    try {
      const payload = {
        appId,
        reason: revenueLossType,
        collectibleAmount: collectibleAmount,
        collectedAmount: collectedAmount
      };
      const response = await CentralRevenueLossStatus(payload);
      if (response?.status === 200) {
        toast.success('Revenue Loss Reason Added Successfully');
        dispatch(configActions.hideSpinningLoader());
        dispatch(centralReportingDataActions.getCentralReportingData({"search_query":appId}));
      } else {
        toast.error('Failed to add Revenue Loss Reason');
        dispatch(configActions.hideSpinningLoader());
      }
    } catch (error) {
      toast.error(error?.message || 'Failed to add Revenue Loss Reason');
      dispatch(configActions.hideSpinningLoader());
    }
  };

  return (
    <div className="textReadOnlyRow">
      <span className="textReadOnlyLabel">Revenue Loss</span>
      <CentralModal
        open={isModalOpen}
        onClose={handleModalClose}
        modalTitle={"Revenue Loss"}
        buttonTitle="Submit"
        cancelTitle="Cancel"
        onSubmit={handleSubmit}
        onCancel={handleModalClose}
        isShowDivider={true}
        isSubmitDisabled={!isDataValid()}
        isModalFooterShow={true}
        modalButton={
          <div className="defaultModalButton" onClick={handleModalOpen}>
            View
          </div>
        }
      >
        <div className="accordionBodyDataContainer">
          <CentralSelect
            value={revenueLossType}
            label="Revenue Loss Type"
            options={REVENUE_LOSS_TYPES}
            onChange={e => setRevenueLossType(e.target.value)}
            placeholder="Select"
          />
          <CentralInputField
            label="Collectible Amount"
            type="number"
            value={collectibleAmount}
            handleOnChange={e => setCollectibleAmount(e.target.value)}
          />
          <CentralInputField
            label="Collected Amount"
            type="number"
            value={collectedAmount}
            handleOnChange={e => setCollectedAmount(e.target.value)}
          />
        </div>
      </CentralModal>
    </div>
  );
};
